<template>
  <div class="login">
    <div class="login-left">
      <div class="login-left-inner">
        <div class="login-left-inner-logo">
          <img src="/img/smaaart-logo.svg" alt="logo" />
        </div>
        <div class="login-left-inner-text" :class="{ 'mb-5': !inspecpro }">
          <h1>
            {{ $t("COMMON.SIGN_IN") }}
          </h1>
          <p>{{ $t("COMMON.LOGIN_WITH_ACCOUNT") }}</p>
        </div>

        <div class="login-left-inner-form">
          <div class="text-center">
            <h2 class="">{{ appConfig.config_manager_app_name }}</h2>
          </div>

          <form role="form">
            <div class="submit-wrapper">
              <base-button @click="login">
                {{ $t("COMMON.SIGN_IN_WITH_SMAAART_AUTH") }}
              </base-button>
            </div>
          </form>
          <div v-if="false" class="forgot-password">
            <router-link :to="{ name: 'PasswordReset' }">
              <small>{{ $t("COMMON.FORGOT_PASSWORD") }}</small>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="login-right">
      <img src="/img/login-image.webp" alt="login" />
      <lang-switcher />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import { LangSwitcher } from "@/components";
import swal from "sweetalert2";

export default {
  components: {
    ValidationError,
    LangSwitcher,
  },
  mixins: [formMixin],
  data: () => ({
    error: null,
    code: null,
    connected: false,
    is_2fa_enabled: false,
    email: "",
    password: "",

    inspecpro: true,
  }),
  async created() {
    swal.fire({
      allowEscapeKey: false,
      allowOutsideClick: false,
      onOpen: () => {
        swal.showLoading();
      },
    });

    await this.login();
  },
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
    ...mapGetters({
      appConfig: "appConfig/appConfig",
    }),
  },
  methods: {
    async login() {
      await this.$store.dispatch("login");
    },

    async handleSubmitCodeVerification() {
      this.error = null;
      const data = {
        data: {
          type: "users",
          attributes: {
            code: this.code,
          },
        },
      };

      try {
        await this.$store.dispatch("users/code_verification", data);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("COMMON.SUCCESS_VERIFICATION"),
        });
      } catch (error) {
        this.error = error?.response?.data?.errors?.[0]?.detail;
        this.$notify({
          type: "danger",
          message: this.$t("COMMON.ERROR_VERIFICATION"),
        });
        error?.response?.data?.errors
          ? this.setApiValidation(error?.response?.data?.errors)
          : null;
      }
    },
  },
};
</script>

<style scoped>
.w-38px {
  width: 38px;
}
.h-38px {
  height: 38px;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) /* #000000 */;
}
.rounded-12px {
  border-radius: 12px;
}
.border-1px {
  border-width: 1px;
  border-style: solid;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) /* #000000 */;
}
.gap-12px {
  gap: 12px;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity)) /* #000000 */;
}
</style>
